import ListDateAbsher from "./ListDataAbsher";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAbsherData } from "../../../../store/Api";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import FileUploadElement from "../../../../ReusableComponents/UploadFile/uplaodFile";

export default function Absher(props) {
  const AbsherData = useSelector((state) => state.absher);
  const dispatch = useDispatch();
  const titleBorder = [{ label: "ABSHER", link: "/dashboard/Absher" }];

  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getAbsherData(token));
  }, []);

  const updateData = () => {
    dispatch(getAbsherData(token));
  };

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  const uploadFile = async (file) => {
    console.log(file);
    if (file) {
      setLoading((p) => ({ ...p, loadingId: file }));
      try {
        const response = await axios.get(
          `/employees/updateBorderNumbersFromExcel/${file}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          apiCall();
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  return (
    <>
      {showPromptElement.open && (
        <FileUploadElement
          title={"Upload Tamplate with Border Number"}
          subTitle={"Upload templete"}
          showFileUploadElement={showPromptElement}
          setShowFileUploadElement={setShowPromptElement}
          uploadFile={uploadFile}
        />
      )}
      <div className={`ml-5 mr-5`}>
        <ListDateAbsher
          list={AbsherData}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "CLIENT",
            "PROJECT COORDINATOR",
            "IQAMA NUMBER",
            "ABSHER STATUS",
            "EMP KSA CONTACT NUMBER",
            "Email",
            // "Status",
            "Action",
          ]}
          token={token}
          updateData={updateData}
          uploadFile={setShowPromptElement}
          absherstatus={["All", "Done", "Pending"]}
        />
      </div>
    </>
  );
}
